module.exports = __webpack_public_path__ + "img/logo-dark.216ebf05.png";